export const SET_CUST_FUND_DETAIL = "SET_CUST_FUND_DETAIL";
